class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterForm = this.querySelector("[data-role='filter']");
    this.sortForm = this.querySelector('[data-role="sort"]');
    this.sortElements = document.querySelectorAll('[data-action="sort"]');
    this.stickyFilter = document.querySelector(
      '[data-role="filter-sticky-mobile"]'
    );
    this.nestedFilterToggle = this.querySelectorAll(
      '[data-role="netsed-filter-toggle"]'
    );
    // debounce inputs change
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      //console.log("input event has been dispatched")
      this.onSubmitHandler(event);
    }, 500);
    this.filterForm.addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );
    // nested filter toggle
    this.nestedFilterToggle.forEach((el) =>
      el.addEventListener("click", function (e) {
        e.preventDefault();
        this.closest("details").removeAttribute("open");
      })
    );
    window.addEventListener("popstate", this.onHistoryChange.bind(this));
    this.sortForm.addEventListener("change", this.debouncedOnSubmit.bind(this));
    // this.collectionFilterSticky.call(this);

    // filter dropdown close on desktop
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".facet-filter") && window.innerWidth > 1024) {
        document
          .querySelectorAll('[data-role="filter"] details')
          .forEach((el) => el.removeAttribute("open"));
      }
      if (!e.target.closest("sort-by") && window.innerWidth > 1024) {
        document
          .querySelector('[data-role="desktop-sort"]')
          .closest("details")
          .removeAttribute("open");
      }
    });
  }

  collectionFilterSticky() {
    this.style.position = "sticky";
    this.style.zIndex = "1000";
    this.style.top = "0px";
    // this.stickyFilter.style.top = `${document.querySelector("[announcement-bar]").clientHeight +
    //     document.querySelector("header").clientHeight
    //     }px`;
    // observing header visibility
    let header = document.querySelector("sticky-header");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const intersecting = entry.isIntersecting;
        if (intersecting) {
          let headerHeight = header.getBoundingClientRect().height + "px";
          this.style.top = headerHeight;
        } else {
          this.style.top = "0px";
        }
      });
    });
    observer.observe(header);
  }

  static toggleDisplay() {
    let filterWrapper = document.querySelector(
      '[data-role="filter-container"]'
    );
    if (!filterWrapper.classList.contains("active")) {
      filterWrapper.classList.add("active");
      document.body.style.overflowY = "hidden";
      setTimeout(() => {
        filterWrapper.style.opacity = "1";
      }, 300);
    } else {
      filterWrapper.style.opacity = "0";
      document.body.style.overflowY = "auto";
      setTimeout(() => {
        filterWrapper.classList.remove("active");
      }, 300);
    }
  }
  // sort toggle
  static sortToggle() {
    let sortWrapper = document.querySelector('[data-role="sort-wrapper"]');
    sortWrapper.classList.toggle("active");
  }
  // form submission handle
  onSubmitHandler = (e) => {
    e.preventDefault();
    const params = FacetFiltersForm.generateParams();
    FacetFiltersForm.fetchData(params);
    FacetFiltersForm.updateHistory(params);
  };
  static clearFilters() {
    let params = window.location.pathname.includes("/search")
      ? window.location.search.split("filter")[0].replace("?", "")
      : "";
    // document.querySelector('[data-role="sort"]').querySelector('select').value = ''
    FacetFiltersForm.fetchData(params);
    FacetFiltersForm.updateHistory(params);
    Array.from(document.querySelectorAll("sort-by")).forEach((el) => {
      el.querySelector(".active")?.classList.remove("active");
    });
  }

  //on history chane
  onHistoryChange = () => {
    const params = window.location.search.replace("?", "");
    FacetFiltersForm.fetchData(params);
  };

  // generate params
  static generateParams() {
    let filterForm = document.querySelector("[data-role='filter']");
    let sortForm = document.querySelector('[data-role="sort"]');
    let searchQuery =
      window.location.pathname == "/search"
        ? window.location.search.split("&filter")[0].replace("?", "")
        : "";

    let filterQueryParams = new URLSearchParams(
      new FormData(filterForm)
    ).toString();
    let sortQueryParams = new URLSearchParams(
      new FormData(sortForm)
    ).toString();
    let params =
      searchQuery != ""
        ? `${searchQuery}&${filterQueryParams}&${sortQueryParams}`
        : `${filterQueryParams}&${sortQueryParams}`;
    return params;
  }

  // update history
  static updateHistory(params) {
    let updateUrl = `${window.location.pathname}?${params}`;
    window.history.pushState({ params }, "", updateUrl);
  }

  // fetch updated data
  static fetchData(params) {
    let sectionId = document.querySelector('[data-module="product-grid"]')
      .dataset.id;
    let elementsToFetch = [
      '[data-role="filter"]',
      '[data-module="product-grid"]',
      '[data-role="filters-count"]',
      '[data-action="desktop-removeFilter"]',
      "[data-pagination]",
      '[data-role="result-count"]',
      '[data-role="active-filters"]',
      '[data-role="desktop-sort"]',
      '[data-role="show-count"]',
    ];
    let url = `${window.location.pathname}?sections=${sectionId}&${params}`;
    document.querySelector('[data-module="product-grid"]').style.opacity =
      "0.5";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let parser = new DOMParser();
        let html = parser.parseFromString(data[sectionId], "text/html");
        // clear filter button mobile view
        if (html.querySelector(".clear-filter-mb")) {
          if (
            html.querySelector(".clear-filter-mb").classList.contains("hidden")
          ) {
            document.querySelector(".clear-filter-mb").classList.add("hidden");
          } else {
            document
              .querySelector(".clear-filter-mb")
              .classList.remove("hidden");
          }
        }
        let collectionHtml = elementsToFetch.map((el) => ({
          element: el,
          content: html.querySelector(el),
        }));
        // render content
        FacetFiltersForm.renderContent(collectionHtml);
        document.querySelector('[data-module="product-grid"]').style.opacity =
          "1";
      })
      .catch((err) => console.error(err));
  }

  // render product grid
  static renderProductGrid(html) {
    let productGrid = document.querySelector('[data-module="product-grid"]');
    productGrid.innerHTML = html;
  }

  // render pagination
  static renderPaginate(html) {
    let paginateWrap = document.querySelector("[data-pagination]");
    paginateWrap.innerHTML = html;
    document.dispatchEvent(new CustomEvent("custom:paginateUpdate"));
  }

  // render filters
  static renderFilters(html) {
    let filterForm = document.querySelector('[data-role="filter"]');
    let openDetails = Array.from(filterForm.querySelectorAll("details[open]"));
    let scrollTopVals = [];
    openDetails.forEach((el) =>
      scrollTopVals.push({
        [`${el.dataset.action}`]: filterForm
          .querySelector(`details[data-action="${el.dataset.action}"]`)
          .querySelector(".filter-inputs__wrapper").scrollTop,
      })
    );

    filterForm.innerHTML = html;
    openDetails.forEach((el) => {
      filterForm.querySelector(`details[data-action="${el.dataset.action}"]`)
        ? filterForm
            .querySelector(`details[data-action="${el.dataset.action}"]`)
            .setAttribute("open", "open")
        : "";
    });
    scrollTopVals.forEach((el) => {
      let detail = filterForm.querySelector(
        `details[data-action="${Object.keys(el)[0]}"]`
      );
      detail
        ? (detail.querySelector(".filter-inputs__wrapper").scrollTop =
            el[Object.keys(el)[0]])
        : "";
    });
  }

  // render active filters
  static renderActiveFilter(html, hide) {
    let activeFilter = document.querySelector('[data-role="active-filters"]');
    activeFilter.innerHTML = html;
    hide
      ? activeFilter.classList.add("hidden")
      : activeFilter.classList.remove("hidden");
  }
  // render count
  static renderCount(html) {
    let countSpan = document.querySelector('[data-role="filters-count"]');
    countSpan.innerHTML = html;
    Number(countSpan.innerText) > 0
      ? countSpan.classList.remove("hidden")
      : countSpan.classList.add("hidden");
  }
  // render show
  static renderShow(html) {
    let show = document.querySelector('[data-role="show-count"]');
    show.innerHTML = html;
  }
  // render search result count
  static searchResultCount(html) {
    let resultCount = document.querySelector('[data-role="result-count"]');
    resultCount ? resultCount.innerHTML = html : '';
  }

  // render removeFilterDesktop
  static updateRemoveBtn(html) {
    let desktopRemoveBtn = document.querySelector(
      '[data-action="desktop-removeFilter"]'
    );
    html.classList.contains("hidden")
      ? desktopRemoveBtn.classList.add("hidden")
      : desktopRemoveBtn.classList.remove("hidden");
  }
  // render desktop sort button
  static updateDesktopSort(html) {
    let desktopSortButton = document.querySelector(
      '[data-role="desktop-sort"]'
    );
    desktopSortButton.innerHTML = html;
  }
  // render content
  static renderContent(html) {
    FacetFiltersForm.renderProductGrid(
      html.find((content) => content.element == '[data-module="product-grid"]')
        .content.innerHTML
    );

    FacetFiltersForm.renderFilters(
      html.find((content) => content.element == '[data-role="filter"]').content
        .innerHTML
    );

    FacetFiltersForm.renderCount(
      html.find((content) => content.element == '[data-role="filters-count"]')
        .content.innerHTML
    );
    FacetFiltersForm.renderShow(
      html.find((content) => content.element == '[data-role="show-count"]')
        .content.innerHTML
    );
    FacetFiltersForm.updateRemoveBtn(
      html.find(
        (content) => content.element == '[data-action="desktop-removeFilter"]'
      ).content
    );

    FacetFiltersForm.renderPaginate(
      html.find((content) => content.element == "[data-pagination]").content
        .innerHTML
    );
    FacetFiltersForm.renderActiveFilter(
      html.find((content) => content.element == '[data-role="active-filters"]')
        .content.innerHTML,
      html
        .find((content) => content.element == '[data-role="active-filters"]')
        .content.classList.contains("hidden")
    );
    window.location.pathname == "/search"
      ? FacetFiltersForm.searchResultCount(
          html.find(
            (content) => content.element == '[data-role="result-count"]'
          )?.content?.innerHTML
        )
      : "";

    FacetFiltersForm.updateDesktopSort(
      html.find((content) => content.element == '[data-role="desktop-sort"]')
        .content.innerHTML
    );
  }
}
customElements.define("facet-filters-form", FacetFiltersForm);

class NestedToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.closest("details").removeAttribute("open");
    });
  }
}
customElements.define("nested-toggle", NestedToggle);
//accordion btn
class accordion extends HTMLElement {
  constructor() {
    super();
    this.querySelector("summary").addEventListener("click", () => {
      if (window.innerWidth >= 768) {
        this.querySelector("details").getAttribute("open")
          ? this.querySelector("details").removeAttribute("open")
          : this.querySelector("details").setAttribute("open", "open");
      }
    });
    this.querySelector("details").addEventListener("click", function () {
      this.closest('[data-role="filter"]')
        ? Array.from(
            this.closest('[data-role="filter"]').querySelectorAll("details")
          ).forEach((el) => {
            el != this ? el.removeAttribute("open") : "";
          })
        : "";
    });
    document.addEventListener("click", (e) => {
      e.target != this && e.target.closest("accordion-btn") != this
        ? this.querySelector("details").removeAttribute("open")
        : "";
    });
  }
}
customElements.define("accordion-btn", accordion);

class ActiveFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      let value = this.dataset.value;
      let form = document.querySelector('[data-role="filter"]');
      let input = document
        .querySelector('[data-role="filter"]')
        .querySelector(`input[value="${value}"]`);
      input.checked = false;
      input.removeAttribute("checked");
      form.dispatchEvent(new Event("input"));
    });
  }
}
customElements.define("active-filter", ActiveFilter);
// sort btn
class SortBtn extends HTMLElement {
  constructor() {
    super();
    this.lists = this.querySelectorAll("input");

    Array.from(this.lists).forEach((el) => {
      el.addEventListener("change", this.toggleActive.bind(this, el));
    });
  }
  toggleActive(el) {
    SortBtn.submitFilter(el);
  }
  static submitFilter(el) {
    let event = new CustomEvent("change");
    let sortForm = document.querySelector('[data-role="sort"]');
    sortForm.querySelector('[name="sort_by"]').value = el.dataset.value;
    sortForm.dispatchEvent(event);
  }
  static clearSort(el) {
    let event = new CustomEvent("change");
    let sortForm = document.querySelector('[data-role="sort"]');
    sortForm.querySelector('[name="sort_by"]').value = "";
    sortForm.dispatchEvent(event);
    let sortWrapper = el
      .closest('[data-role="sort-wrapper"]')
      .querySelector("sort-by");
    let inputs = sortWrapper.querySelectorAll("input");
    inputs.forEach((el) => (el.checked = false));
  }
}

customElements.define("sort-by", SortBtn);

//filter toggle in mobile
document.addEventListener("click", (e) => {
  if (
    e.target.dataset.role == "filter-toggle" ||
    e.target.closest('[data-role="filter-toggle"]')
  ) {
    e.preventDefault();
    FacetFiltersForm.toggleDisplay();
  }
});
//sort toggle in mobile
document.addEventListener("click", (e) => {
  if (
    e.target.dataset.role == "sort-toggle" ||
    e.target.closest('[data-role="sort-toggle"]')
  ) {
    FacetFiltersForm.sortToggle();
  }
});
// clear filters
document.addEventListener("click", (e) => {
  if (
    e.target.dataset.role == "removeFilters" ||
    e.target.closest('[data-role="removeFilters"]')
  ) {
    e.preventDefault();
    FacetFiltersForm.clearFilters();
    window.innerWidth < 768 ? FacetFiltersForm.toggleDisplay() : "";
  }
});
// clear sort
document.addEventListener("click", (e) => {
  if (
    e.target.dataset.role == "clearSort" ||
    e.target.closest('[data-role="clearSort"]')
  ) {
    SortBtn.clearSort(e.target);
  }
});
//pagination
class Pagination extends HTMLElement {
  constructor() {
    super();
    this.init.call(this);
    document.addEventListener("custom:paginateUpdate", this.init.bind(this));
    document.addEventListener("custom:loadProduct", (e) => {
      if (!this.loadMoreBtn.classList.contains("active")) {
        this.fetchProduct.call(this);
      }
    });
  }
  init() {
    this.behavior = this.dataset.behavior;
    this.observer;
    this.productGrid = document.querySelector("search-product-grid")
      ? document.querySelector("search-product-grid")
      : document.querySelector("collection-product-grid");
    this.loadMoreBtn = document.querySelector('[data-role="paginate"]');

    this.addEventListener("click", (e) => {
      if (
        e.target.dataset.role == "paginate" ||
        e.target.closest('[data-role="paginate"]')
      ) {
        this.fetchProduct.bind(this)();
      }
    });
    this.loadMoreBtn ? this.handleIntersection.call(this) : "";
  }
  // fetchProduct
  fetchProduct() {
    this.loadMoreBtn.classList.add("active");
    this.loadMoreBtn = document.querySelector('[data-role="paginate"]');
    let url = window.location.pathname.includes("/search")
      ? `search/?sections=${
          this.dataset.section
        }&${window.location.search.replace("?", "")}&page=${
          this.loadMoreBtn.dataset.page
        }`
      : `${window.location.pathname}/?sections=${this.dataset.section}&page=${
          this.loadMoreBtn.dataset.page
        }&${window.location.search.replace("?", "")}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let sectionData = data[this.dataset.section];
        let parser = new DOMParser();
        let html = parser.parseFromString(sectionData, "text/html");
        let count = html.querySelector(
          '[data-role="product=-count"]'
        ).innerHTML;
        this.renderProductCount(count);
        this.renderContent(html);
        html
          .querySelector(".pagination-loadMore__btn")
          .classList.contains("hidden")
          ? this.loadMoreBtn.classList.add("hidden")
          : this.loadMoreBtn.classList.remove("hidden");
        this.loadMoreBtn.classList.remove("active");
      });
  }

  // handle intersection
  handleIntersection() {
    const intersection = (entries) => {
      entries.map((entry) => {
        if (
          entry.isIntersecting &&
          !this.loadMoreBtn.classList.contains("active")
        ) {
          let clickEvent = new CustomEvent("custom:loadProduct");
          document.dispatchEvent(clickEvent);
        }
      });
    };
    const options = {
      threshold: 1,
      rootMargin: "600px",
    };
    this.observer
      ? ""
      : (this.observer = new IntersectionObserver(intersection, options));
    this.observer.observe(this.loadMoreBtn);
  }

  // renderProduct grid
  renderProductGrid(html) {
    let productGrid = document.querySelector(
      '[data-slot="product-grid-items"]'
    );
    productGrid.insertAdjacentHTML("beforeend", html.innerHTML);
  }
  renderProductCount(count) {
    let productCountContainer = document.querySelectorAll(
      '[data-role="product=-count"]'
    );
    productCountContainer.forEach((el) => (el.innerHTML = count));
  }
  //update load more button data attributes
  updateLoadMoreBtn(html) {
    let paginate = document.querySelector("[data-pagination]");
    paginate.innerHTML = html;
    this.loadMoreBtn = document.querySelector('[data-role="paginate"]');
    this.loadMoreBtn ? this.handleIntersection.call(this) : "";
  }

  // render content
  renderContent(html) {
    let sectionToLoad = [
      '[data-slot="product-grid-items"]',
      "[data-pagination]",
    ];
    let content = sectionToLoad.map((section) => ({
      element: section,
      htmlContent: html.querySelector(section),
    }));
    this.renderProductGrid(
      content.find((el) => el.element == '[data-slot="product-grid-items"]')
        .htmlContent
    );
    this.updateLoadMoreBtn(
      content.find((el) => el.element == "[data-pagination]").htmlContent
        .innerHTML
    );
  }
}

customElements.define("paginate-grid", Pagination);

// layout switch
class LayoutSwitch extends HTMLElement {
  constructor() {
    super();

    this.layout = "layout-1";
    // debounce inputs change
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
    this.debounceChange = debounce((event) => {
      this.updateLayout(event.target.value);
    }, 500);

    this.addEventListener("change", this.debounceChange.bind(this));
  }
  updateLayout(layout) {
    let collectionProductGrid = document.querySelector(
      ".main-collection-wrapper"
    );
    collectionProductGrid.classList.remove("layout-1");
    collectionProductGrid.classList.remove("layout-2");
    collectionProductGrid.classList.remove("layout-3");
    collectionProductGrid.classList.add(layout);
  }
}
customElements.define("layout-switch", LayoutSwitch);
